import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/styles.css";

const ImageLightBox = ({images, open, close}) => {
  const slides = images?.map((img) => ({ src: img.image }));

    return (
        <div className={`absolute top-1 pe-5 z-10`}>
            {open && (
                <Lightbox
                    open={open}
                    close={() => close(prev => !prev)}
                    slides={slides}
                    zoom={{
                        scrollToZoom:true,
                        maxZoomPixelRatio:5
                    }}
                    plugins={[Fullscreen, Slideshow, Thumbnails, Video, Zoom]}
                />
            )}
        </div>
    );
};

export default ImageLightBox;
